import actions from './actions';

export const initialState = {
  isVisible: true,
  y: 0
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.visibility:
      const previousY = state.y;
      const currentY = action.y;
      const threshold = action.threshold;

      if (isDownwardScroll(currentY, previousY)) {
        if (!state.isVisible || wasScrolledPastThreshold(currentY, previousY, threshold)) {
          return {
            ...state,
            y: currentY,
            isVisible: false
          };
        }
      }

      return {
        ...state,
        y: currentY,
        isVisible: true
      };
    default:
      return state;
  }
};

function isDownwardScroll(currentY, previousY) {
  return currentY > previousY;
}

function wasScrolledPastThreshold(currentY, previousY, threshold) {
  return currentY - threshold > previousY;
}


// WEBPACK FOOTER //
// ./src/components/scroll-show/reducer.js